// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"106":"cd702d838fa41ab3a925","202":"b62683a8d059710d7ad1","210":"1b57091fe3ab4ed36d0c","265":"ee647b315dbf6c7b4ba8","394":"c6d47d465f7b725d2c0e","670":"99fbacba04ddc9164180","868":"e8b27fe073d02b19e64a","885":"d82a6c3e270bbf087b22","928":"eb7fcccc9960cc5fec74"}[chunkId] + ".js";
};